import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=cbb46ee8&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbb46ee8')) {
      api.createRecord('cbb46ee8', component.options)
    } else {
      api.reload('cbb46ee8', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=cbb46ee8&", function () {
      api.rerender('cbb46ee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fXoMIgTlwGWg/JS/videoIframe.vue"
export default component.exports